<template>
  <asc-page-header class="asc-grid-export-header">
    <template slot="pageTitle">
      <asc-page-title :title="title"></asc-page-title>
    </template>
    <template v-if="exportButtonVisible" slot="pageActions">
      <asc-split-button
        class="asc-grid-export-header--exportButton"
        :items="menuItems"
        :button-text="getButtonText"
        :on-item-click="handleMenuItemClick"
        :disabled="exportButtonDisabled"
      ></asc-split-button>
    </template>
  </asc-page-header>
</template>

<script>
import { AscGridPropsMixin } from '@/components/mixins'
import AscSplitButton from '@/components/atoms/AscSplitButton'
import AscPageHeader from '@/components/atoms/AscPageHeader'
import AscPageTitle from '@/components/atoms/AscPageTitle'

export default {
  name: 'AscReportGridExportHeader',

  components: {
    AscSplitButton,
    AscPageHeader,
    AscPageTitle,
  },

  mixins: { AscGridPropsMixin },

  props: {
    title: {
      type: String,
      default: '',
    },
    exportButtonVisible: {
      type: Boolean,
      default: false,
    },
    onExportOptions: {
      type: Function,
      default: () => {},
    },
    onApuCycleExport: {
      type: Function,
      default: () => {},
    },
    onFaultMonitorExport: {
      type: Function,
      default: () => {},
    },
    onFleetAlertsExport: {
      type: Function,
      default: () => {},
    },
    onFleetMessagesExport: {
      type: Function,
      default: () => {},
    },
    exportButtonDisabled: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      menuItems: [
        { title: 'Export Fleet Reports', value: 0, disabled: false },
        { title: 'Export APU Cycles', value: 1, disabled: false },
        { title: 'Export Fault Monitors', value: 2, disabled: false },
        { title: 'Export Fleet Alerts', value: 3, disabled: false },
        { title: 'Export Fleet Messages', value: 4, disabled: false },
      ],
    }
  },

  computed: {
    isExportSelectedButtonEnabled() {
      return this.selectedItems.length > 0
    },
    isExportByDateButtonEnabled() {
      return true
    },
    getButtonText() {
      return `Export`
    },
  },

  methods: {
    handleMenuItemClick(id) {
      if (id === 0) {
        if (this.onExportOptions) {
          this.onExportOptions()
        }
      }
      if (id === 1) {
        if (this.onApuCycleExport) {
          this.onApuCycleExport()
        }
      }
      if (id === 2) {
        if (this.onFaultMonitorExport) {
          this.onFaultMonitorExport()
        }
      }
      if (id === 3) {
        if (this.onFleetAlertsExport) {
          this.onFleetAlertsExport()
        }
      }
      if (id === 4) {
        if (this.onFleetMessagesExport) {
          this.onFleetMessagesExport()
        }
      }
    },
  },
}
</script>

<style lang="scss">
.asc-grid-export-header {
  display: flex;

  &--exportButton {
    display: flex;
    justify-content: flex-end;
    padding-right: 10px;
  }
}
</style>
